// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"e7e66d36","232":"a6272568","315":"5abf4d2a","503":"a498f7b3","764":"6b9fa8c6","777":"cbc36638","941":"637687bb"}[chunkId] + ".chunk.js";
};